/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../../widgets/livewidget/nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (_, $, StringResources, ReactDOM, React, Toolkit, PropTypes) {

	const { Container, Label, RadioGroup } = Toolkit;
	class DrillThroughDefinitionScope extends React.Component {

		constructor(props) {
			super(props);
			this.state = {
				checked : props.checked
			};
		}

		render() {

			const options = [{
				label: StringResources.get('drillthroughScopeRadioOptionVisualization'),
				value: 'visualization'
			}, {
				label: StringResources.get('drillthroughScopeRadioOptionConnection'),
				value: 'connection'
			}, {
				label: StringResources.get('drillthroughScopeRadioOptionDashboard', {
					perspective: this.props.applicationName
				}),
				value: 'dashboard'
			}];
			return (<Container className='dtEditFooter'>
				<Label id='dtScopeRadioLabel' type='caption' label={StringResources.get('drillthroughScopeRadioLabel')} />
				<RadioGroup
					direction='vertical'
					options={options}
					aria-labelledby='dtScopeRadioLabel'
					checked={this.state.checked}
					onChange={(value) => {this._onScopeChange(value);}}
				/>
			</Container>);
		}

		_onScopeChange(value) {
			this.setState({ checked: value });
			this.props.onChange(value);
		}
	}

	DrillThroughDefinitionScope.propTypes = {
		checked: PropTypes.string,
		onChange: PropTypes.func,
		applicationName: PropTypes.string
	};
	return DrillThroughDefinitionScope;

});

